import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import RulesLayer from "../components/RulesLayer";

const RulesPage = () => {
  return (
    <>
      <Breadcrumb title="Rules" />
      <RulesLayer />
    </>
  );
};

export default RulesPage;